(function() {
    'use strict';
    angular
        .module('showcaseApp')
        .factory('ReportFactory', ReportFactory);

    ReportFactory.$inject = ['$resource'];

    function ReportFactory($resource) {
        var resourceUrl = '';

        return $resource(resourceUrl, {}, {

            'listUsersRegisteredByGenderWithCouponGeneratedByStore': {
                method: 'POST',
                isArray: true,
                url: '/api/report/users-by-gender',
                transformResponse: function(data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'listMostLikedCategories': {
                method: 'POST',
                url: '/flyer/api/report/coupon/most-liked-categories',
                transformResponse: function(data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'listUsersGenerateMoreCoupons': {
                method: 'POST',
                isArray: true,
                url: '/api/report/users-generate-more-coupons',
                transformResponse: function(data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'listUsersWithMoreCouponsRedeemed': {
                method: 'POST',
                isArray: true,
                url: '/api/report/users-with-more-coupons-redeemed',
                transformResponse: function(data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'listUsersFirstInteraction': {
                method: 'POST',
                isArray: true,
                url: '/flyer/api/report/coupon/users-first-interaction',
                transformResponse: function(data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            }

        });
    }
})();
